module.exports = __webpack_public_path__ + "static/img/img.39992a26.png";